module.exports = __webpack_public_path__ + "media/reskin-images/icon--circle-x-ee3db6e2.svg";